module.exports = __webpack_public_path__ + "static/media/pdm.2d284e47.svg";